import { ArrowRight, Clock, Sparkle } from "lucide-react";
import { BrandHeader } from "@/components/BrandHeader";
import { ASSETS } from "@/lib/assets";

const DISCOVER = [
  "Your primary feminine energy profile.",
  "Where your energy feels most concentrated.",
  "Patterns that may be interrupting your flow.",
  "Your personal strengths and opportunities for expansion.",
  "Your recommended Goddess University learning journey.",
  "Two courses that align with your current needs.",
  "Your next opportunities for education, practice, and personalized support.",
];

export default function Welcome({ onBegin }) {
  return (
    <div data-testid="welcome-screen">
      <BrandHeader />
      <main className="fea-container grid lg:grid-cols-[1.05fr_1fr] gap-10 lg:gap-16 items-start pt-6 sm:pt-10">
        <div className="fea-rise lg:sticky lg:top-24">
          <img src={ASSETS.welcome} alt="A woman journaling beside the Feminine Energy Assessment" className="w-full rounded-[28px] shadow-[0_24px_60px_-30px_rgba(128,5,52,0.45)] object-cover max-h-[78vh]" data-testid="welcome-image" />
        </div>
        <section className="fea-rise fea-delay-1">
          <p className="fea-overline">Goddess University presents</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#800534] leading-[1.05] mt-3" data-testid="welcome-title">
            Feminine Energy Assessment<sup className="text-2xl align-super">™</sup>
          </h1>
          <h2 className="font-serif italic text-base md:text-lg text-[#3B121A] mt-5">Discover where you are in your feminine energy.</h2>
          <div className="fea-body mt-6 space-y-4">
            <p>Your feminine energy influences how you receive, create, connect, restore yourself, and experience your world.</p>
            <p>This assessment helps you explore where your energy is flowing naturally, where it may feel concentrated or restricted, and what is ready for your attention.</p>
          </div>
          <div className="fea-card mt-8 !p-6 sm:!p-8">
            <p className="fea-overline mb-4">You'll discover</p>
            <ul className="space-y-3" data-testid="welcome-discover-list">
              {DISCOVER.map((d) => (
                <li key={d} className="flex gap-3 fea-body">
                  <Sparkle className="h-4 w-4 mt-1.5 shrink-0 text-[#C9A13B]" />
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="fea-body mt-8 space-y-2">
            <p>There are no right or wrong answers.</p>
            <p>Answer according to what feels true for you right now.</p>
            <p className="flex items-center gap-2 text-[#800534] font-medium pt-1"><Clock className="h-4 w-4" /> Estimated completion time: 5–7 minutes.</p>
          </div>
          <button onClick={onBegin} className="fea-btn mt-8 w-full sm:w-auto" data-testid="begin-assessment-button">
            Begin My Assessment <ArrowRight className="h-5 w-5" />
          </button>
        </section>
      </main>
      <footer className="fea-footer">© Goddess University · Founded by Rev. Goddess LaMeel</footer>
    </div>
  );
}
